import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import { FormMdxEditor } from '@/components/forms'

/**
 * Instructions Tab - Main and post-call prompts
 *
 * Includes:
 * - Main prompt editor with MDXEditor (rich text/markdown)
 * - Post-call prompt editor with MDXEditor
 * - Support for diff view (revision comparison)
 */
export function InstructionsTab() {
  const { t } = useTranslation()
  const { control } = useFormContext()

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
          {t('resources.assistants.instructions.title')}
        </h2>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {t('resources.assistants.instructions.description')}
        </p>
      </div>

      <div className="space-y-8 rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-900">
        {/* Main Prompt */}
        <div>
          <FormMdxEditor
            name="prompt"
            label={t('resources.assistants.instructions.main_prompt')}
            description={t('resources.assistants.instructions.main_prompt_description')}
            placeholder={t('resources.assistants.instructions.main_prompt_placeholder')}
            control={control}
            minHeight="300px"
            maxHeight="none"
            showDiffView={true}
          />
        </div>

        {/* Post-Call Prompt */}
        <div>
          <FormMdxEditor
            name="post_call_prompt"
            label={t('resources.assistants.instructions.post_call_prompt')}
            description={t('resources.assistants.instructions.post_call_prompt_description')}
            placeholder={t('resources.assistants.instructions.post_call_prompt_placeholder')}
            control={control}
            minHeight="150px"
            maxHeight="400px"
            showDiffView={true}
          />
        </div>
      </div>
    </div>
  )
}
